import { Component, OnInit } from '@angular/core';
import { TranslateService } from "../../../../common/variables/translate-service";

@Component({
  selector: 'sen-app-extra-services',
  templateUrl: './extra-services.component.html',
  styleUrls: ['./extra-services.component.scss']
})
export class ExtraServicesComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
